<template>
    <NotificationRow v-if="promoNotification"
                     :notification="promoNotification"
                     @click="emit('click')" />
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import NotificationRow from '@/js/quests/dashboard/modals/notifications/header-notifications/NotificationRow.vue';
    import { useMarketingStore } from '@/js/store/quests/dashboard/MarketingStore';

    const emit = defineEmits<{(e: 'click'): void }>();

    const marketingStore = useMarketingStore();

    const promoNotification = computed(() => {
        if (!marketingStore.notificationData) {
            return null;
        }

        return {
            title: marketingStore.notificationData.title,
            subtitle: marketingStore.notificationData.subtitle,
            image_path: 'assets/missions/notifications/bits-earned.svg',
            read_at: '2025-10-05T23:59:59.000000Z',
            url: marketingStore.notificationData.route,
        };
    });

</script>
